// -----------------------------------------------------------------------------
// PlansModal.jsx – cartes pricing FR + coche + dégradés fidèles à la maquette
// -----------------------------------------------------------------------------
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

export default function PlansModal({ open, onClose }) {
  const plans = [
    {
      key: "basic",
      title: "Basique",
      description: "Pour les particuliers",
      price: "10 €",
      billing: "Par mois\nfacturé annuellement",
      features: [
        "Toutes les fonctionnalités d’analyse",
        "Jusqu’à 250 000 visites suivies",
        "Support standard",
        "Jusqu’à 3 membres d’équipe",
      ],
      btnColor: "#121a34",
      bg: "linear-gradient(180deg,#ffffff 0%,#f4f8ff 100%)",
      text: "#121a34",
    },
    {
      key: "premium",
      title: "Premium",
      description: "Pour les particuliers",
      price: "10 €",
      billing: "Par mois\nfacturé annuellement",
      features: [
        "Toutes les fonctionnalités d’analyse",
        "Jusqu’à 250 000 visites suivies",
        "Support standard",
        "Jusqu’à 3 membres d’équipe",
      ],
      isPopular: true,
      btnColor: "#f6a72f",
      bg: "linear-gradient(180deg,#0d1c3d 0%,#162b6f 100%)",
      text: "#ffffff",
    },
    {
      key: "pro",
      title: "Pro",
      description: "Pour les particuliers",
      price: "10 €",
      billing: "Par mois\nfacturé annuellement",
      features: [
        "Toutes les fonctionnalités d’analyse",
        "Jusqu’à 250 000 visites suivies",
        "Support standard",
        "Jusqu’à 3 membres d’équipe",
      ],
      btnColor: "#121a34",
      bg: "linear-gradient(180deg,#ffffff 0%,#f4f8ff 100%)",
      text: "#121a34",
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={(_, r) => r !== "backdropClick" && onClose()}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { overflow: "visible", borderRadius: 3, pb: 4 } }}
    >
      {/* Titre + bouton X */}
      <Box sx={{ position: "relative", textAlign: "center", pt: 4 }}>
        <DialogTitle sx={{ fontSize: "2.4rem", fontWeight: 800, p: 0, mb: 1 }}>
          Plans tarifaires abordables
        </DialogTitle>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ maxWidth: 540, mx: "auto", whiteSpace: "pre-line" }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id arcu,
          convallis est sed. Proin nulla eu a vitae lectus leo suscipit.
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8, color: "#121a34" }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ mt: 4 }}>
        <Grid container spacing={3} justifyContent="center">
          {plans.map((p) => (
            <Grid item xs={12} sm={6} md={4} key={p.key}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  background: p.bg,
                  color: p.text,
                  boxShadow:
                    "0px 8px 24px rgba(25, 25, 46, 0.06), 0px 4px 12px rgba(25, 25, 46, 0.04)",
                  position: "relative",
                }}
              >
                {p.isPopular && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 16,
                      right: 16,
                      bgcolor: "#f6a72f",
                      color: "#ffffff",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      px: 1.5,
                      py: 0.25,
                      borderRadius: 2,
                    }}
                  >
                    Populaire
                  </Box>
                )}

                <CardContent sx={{ px: 4, pt: 6, pb: 4 }}>
                  <Typography variant="h5" fontWeight={700} gutterBottom>
                    {p.title}
                  </Typography>
                  <Typography variant="caption" display="block" sx={{ mb: 3 }}>
                    {p.description}
                  </Typography>

                  {/* Prix */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <Typography variant="h3" fontWeight={700}>
                      {p.price}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ whiteSpace: "pre-line", lineHeight: 1.2 }}
                    >
                      {p.billing}
                    </Typography>
                  </Box>

                  {/* CTA */}
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      bgcolor: p.btnColor,
                      color: p.text === "#ffffff" ? "#162b6f" : "#ffffff",
                      fontWeight: 700,
                      textTransform: "none",
                      borderRadius: 5,
                      height: 44,
                      mb: 4,
                      "&:hover": {
                        bgcolor:
                          p.btnColor === "#f6a72f" ? "#d88d22" : "#0e1330",
                      },
                    }}
                  >
                    Mettre à niveau
                  </Button>

                  {/* Fonctionnalités */}
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Ce qui est inclus
                  </Typography>
                  {p.features.map((f) => (
                    <Box
                      key={f}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      <CheckIcon
                        sx={{
                          fontSize: 18,
                          color: p.text === "#ffffff" ? "#ffffff" : "#162b6f",
                        }}
                      />
                      <Typography variant="body2">{f}</Typography>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
